<template>
  <div>
    <!-- NOW SHOWING SECTION -->
    <section class="section-404">
      <div class="section-space-50 d-none d-md-block"></div>

      <div class="container my-5">
        <div class="d-flex justify-content-center align-items-center px-5">
          <div>
            <img src="@/assets/img/icons/4.svg" class="img-fluid" alt="404 Icon" />
          </div>
          <div class="mx-3">
            <img src="@/assets/img/icons/popcorn404.svg" class="img-fluid" alt="404 Icon" />
          </div>
          <div>
            <img src="@/assets/img/icons/4.svg" class="img-fluid" alt="404 Icon" />
          </div>
        </div>

        <div class="text-404 text-center my-5 my-md-4">
          <h5>Uh-oh!</h5>
          <p>
            Looks like someone is lost while searching for their favorite movie!
            <br />No worries, let’s take you back home :)
          </p>
        </div>

        <div class="text-center">
          <button class="btn btn-primary px-4">BACK TO HOME</button>
        </div>
      </div>
      <div class="section-space-50 d-none d-md-block"></div>
    </section>

    <!-- DONWLOAD APP COMPONENTS -->
    <DownloadApp />
    <!-- <div class="col-12 d-md-none">
      <div class="my-3 text-center copyRight-text">© Miraj Cinemas 2020 All Rights Reserved.</div>
    </div>
    <div class="rainbow-line">
      <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import DownloadApp from "@/components/partials/downloadApp";
// setUserName
export default {
  data() {
    return {};
  },
  components: {
    DownloadApp
  },
  computed: {},
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/pages/404.vue